<template>
  <div class="editor">
    <div class="editorBlock">
      <textarea
        class="textarea"
        contenteditable
        :maxlength="data.max || 1000"
        @focus="focus = true"
        @blur="focus = false"
        v-model="model" />
    </div>
    <div class="title" :class="{focus: focus, notnull: model && (model.length > 0)}">
      {{ data.label || '' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data () {
    return {
      focus: false,
      model: null
    }
  },
  watch: {
    model (val) {
      this.$emit('set', val)
    }
  },
  mounted () {
    this.model = this.data.value || ''
  },
  updated () {
    this.model = this.data.value || ''
  }
}
</script>

<style lang="scss" scoped>
.editor{
  @include box(100%, auto, relative, 0, 0, null, null, 0, null);
  @include flex(center, center, column);
  @include padding(0, 2vw, 0, 0);
  .title{
    @include box(100%, 2.5vw, absolute, 0, 2.3vw, null, null, 0, null);
    @include text(0.85vw, 400, null, null, left, $inputLabel);
    @include flex(left, center, row);
    @include padding(1vw, 0, 0, 0);
    &.focus{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
      @include padding(0, 0, 0, 0);
    }
    &.notnull{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
      @include padding(0, 0, 0, 0);
    }
  }
  .editorBlock{
    @include box(100%, 16.3vw, relative, 0, 0, null, null, null, $input);
    @include border(0.06vw, solid, $inputBorder, null, null, null, null);
    .textarea{
      @include box(100%, 100%, absolute, 0, 0, null, null, null, $input);
      @include text(0.8vw, 400, null, null, left, $inputColor);
      @include padding(1vw, 1vw, 1vw, 1vw);
      z-index: 2;
      min-height: 100%;
      border: 0;
      outline: none;
      resize: none;
    }
  }
}
</style>
